// Part of the agent UI for spark#246 / @adr SPARK-0034-ai-agents-are-project-context-not-team-members@2: an AI agent is PROJECT CONTEXT, never a team
// member. Nothing here reaches the solver, and no agent carries a Powers profile — Powers is a
// psychometric instrument built for humans, and putting agents on that scale would argue they are
// interchangeable with candidates, which is the model @adr SPARK-0034-ai-agents-are-project-context-not-team-members@2 rejects.

/** `sm` is the 32px row-avatar size the topbar search uses for every hit. */
export function AgentMonogram({ name, size = "md" }: { name: string; size?: "md" | "sm" }) {
  const initials = name
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
  return (
    <span
      className={`flex shrink-0 items-center justify-center font-serif ${
        size === "sm" ? "h-8 w-8 text-smycles-label" : "h-10 w-10 text-smycles-body"
      }`}
      style={{ background: "var(--color-accent)", color: "var(--color-on-accent)" }}
      aria-hidden
    >
      {initials}
    </span>
  );
}
